import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
    this.#applyImageWidths();
  }

  /**
   * Honor HTML width attributes as inline styles.
   * Author CSS (Horizon's img { width: 100% }) otherwise beats the attribute
   * and large intrinsic files (e.g. 30day.png @ 1184px) fill the column.
   */
  #applyImageWidths() {
    this.querySelectorAll('img[width]').forEach((img) => {
      if (img.style.width) return;
      const w = Number.parseInt(img.getAttribute('width') || '', 10);
      if (!Number.isFinite(w) || w <= 0) return;
      img.style.width = `${w}px`;
      img.style.maxWidth = '100%';
      img.style.height = 'auto';
    });
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
